import ProductCalculationsRestApi from 'api/digifi/ProductCalculationsApi';
import AddressLookupRestApi from 'api/digifi/AddressLookupApi';
import VariablesRestApi from 'api/digifi/VariablesApi';
import LayoutConfigurationRestApi from 'api/digifi/layout/LayoutConfigurationApi';
import ApplicationsRestApi from 'api/digifi/ApplicationsApi';
import AdminAuthApi from 'api/digifi/AdminAuthApi';
import PortalPageElementsRestApi from 'api/digifi/PortalPageElementsApi';
import TasksRestApi from 'api/digifi/TasksApi';
import AutomationWorkflowsApi from 'api/digifi/AutomationWorkflowsApi';
import EnvironmentApi from 'api/EnvironmentApi';
import TasksDetailsRestApi from 'api/digifi/TaskDetailsApi';
import PortalPageInfoRestApi from 'api/digifi/PortalPageInfoApi';
import DocuSignRestApi from 'api/digifi/DocuSignApi';
import GoogleAnalyticsRestApi from 'api/digifi/GoogleAnalyticsApi';
import PortalLandingPageElementsRestApi from 'api/digifi/PortalLandingPageElementsApi';
import PlaidRestApi from 'api/digifi/PlaidApi';
import SessionsRestApi from 'api/digifi/SessionsApi';
import PhoneVerificationRestApi from 'api/digifi/PhoneVerificationApi';
import EmailVerificationRestApi from 'api/digifi/EmailVerificationApi';
import ResetPasswordRestApi from 'api/digifi/ResetPasswordApi';
import { getAccountsApi, getInvitesApi, getSettingsApi, noRedirectRoutes, unauthorizeRedirectUrl } from './apiBuilders';
import BorrowersRestApi from 'api/digifi/BorrowersApi';
import LoggerApi from 'api/LoggerApi';
import DocumentsRestApi from 'api/digifi/DocumentsApi';
import RecaptchaRestApi from 'api/digifi/RecaptchaApi';
import IntermediaryRestApi from 'api/digifi/IntermediaryApi';
import ApplicationStatusesApi from 'api/digifi/ApplicationStatusesApi';
import LexisNexisRestApi from 'api/digifi/LexisNexisApi';
import QuilttRestApi from 'api/digifi/QuilttApi';
import ApplicationDocumentUploadsRestApi from 'api/digifi/ApplicationDocumentUploadApi';
import PresignedUploadRestApi from 'api/digifi/PresignedUploadApi';
import { BorrowersInviteRestApi } from 'api/digifi/BorrowersInviteApi';
import PandaDocRestApi from 'api/digifi/PandaDocApi';

export const productCalculationsApi = new ProductCalculationsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const addressLookupApi = new AddressLookupRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const variablesApi = new VariablesRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const layoutConfigurationApi = new LayoutConfigurationRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const adminAuthApi = new AdminAuthApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const applicationsApi = new ApplicationsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const portalPageElementsApi = new PortalPageElementsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const tasksApi = new TasksRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const automationWorkflowsApi = new AutomationWorkflowsApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const environmentApi = new EnvironmentApi();
export const taskDetailsApi = new TasksDetailsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const portalPageInfoApi = new PortalPageInfoRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const docuSignApi = new DocuSignRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const pandaDocApi = new PandaDocRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const googleAnalyticsApi = new GoogleAnalyticsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const plaidApi = new PlaidRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const portalLandingPageElementsApi = new PortalLandingPageElementsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const borrowersApi = new BorrowersRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const intermediaryApi = new IntermediaryRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const accountsApi = getAccountsApi();
export const invitesApi = getInvitesApi();
export const settingsApi = getSettingsApi();
export const sessionsApi = new SessionsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const phoneVerificationApi = new PhoneVerificationRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const emailVerificationApi = new EmailVerificationRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const resetPasswordApi = new ResetPasswordRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const loggerApi = new LoggerApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const documentsApi = new DocumentsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const recaptchaApi = new RecaptchaRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const lexisNexisApi = new LexisNexisRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const applicationStatusesApi = new ApplicationStatusesApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const quilttApi = new QuilttRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const applicationDocumentUploadsApi = new ApplicationDocumentUploadsRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
export const presignedUploadApi = new PresignedUploadRestApi();
export const borrowersInviteApi = new BorrowersInviteRestApi(unauthorizeRedirectUrl, noRedirectRoutes);
